export const AnyBranchId: string = '0-Any Branch';
